import { render, staticRenderFns } from "./bet-set.vue?vue&type=template&id=089561e8"
import script from "./bet-set.vue?vue&type=script&lang=js"
export * from "./bet-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('089561e8')) {
      api.createRecord('089561e8', component.options)
    } else {
      api.reload('089561e8', component.options)
    }
    module.hot.accept("./bet-set.vue?vue&type=template&id=089561e8", function () {
      api.rerender('089561e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/bet-set.vue"
export default component.exports